
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.765 24H7.231a2.262 2.262 0 01-2.245-2.272L3.876 4.854a.5.5 0 01.467-.532.512.512 0 01.532.467L5.985 21.7A1.27 1.27 0 007.231 23h9.534a1.262 1.262 0 001.248-1.272l1.112-16.939a.508.508 0 01.532-.467.5.5 0 01.466.532L19.012 21.76A2.255 2.255 0 0116.765 24z"}}),_c('path',{attrs:{"d":"M16.521 5.193a.5.5 0 01-.5-.482l-.095-2.743c0-.532-.315-.968-.687-.968H8.762c-.373 0-.688.436-.688.951L7.979 4.71a.482.482 0 01-.517.483.5.5 0 01-.482-.517l.094-2.742A1.83 1.83 0 018.762 0h6.478a1.835 1.835 0 011.686 1.951l.1 2.725a.5.5 0 01-.482.517z"}}),_c('path',{attrs:{"d":"M22 5.193H2a.5.5 0 010-1h20a.5.5 0 010 1zM8.8 20.7a.5.5 0 01-.5-.47L7.617 8.612a.5.5 0 01.47-.528.51.51 0 01.528.47L9.3 20.169a.5.5 0 01-.47.528zm3.027 0a.5.5 0 01-.5-.475l-.383-7.74a.5.5 0 01.475-.525.485.485 0 01.524.475l.383 7.74a.5.5 0 01-.475.525z"}})])
          )
        }
      }
    